import { render, staticRenderFns } from "./RiskCollectCountList.vue?vue&type=template&id=32f71ca8&scoped=true"
import script from "./RiskCollectCountList.vue?vue&type=script&lang=js"
export * from "./RiskCollectCountList.vue?vue&type=script&lang=js"
import style0 from "./RiskCollectCountList.vue?vue&type=style&index=0&id=32f71ca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f71ca8",
  null
  
)

export default component.exports